import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";
import axios from "axios";
import { CookiesProvider, useCookies } from "react-cookie";
import { RBACProvider } from "react-simple-rbac";
import fetchAdapter from "@vespaiach/axios-fetch-adapter";
import "antd/dist/antd.css";
import "./index.css";
import App from "./App";
import Login from "./login";
import reportWebVitals from "./reportWebVitals";

axios.defaults.baseURL = process.env.REACT_APP_API_URI;

axios.defaults.withCredentials = true;

axios.defaults.adapter = fetchAdapter;

axios.defaults.headers.common["Content-Type"] = "application/json";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      window.location = "/login";
    } else {
      return Promise.reject(error);
    }
  }
);

function Private({ children }) {
  // let location = useLocation();

  // const [cookies, setCookie] = useCookies();

  // console.log(cookies);

  // if (!cookies.Authorization) {
  //   return <Navigate to="/login" state={{ from: location }} replace />;
  // }

  return children;
}

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <RBACProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="*"
              element={
                <Private>
                  <App />
                </Private>
              }
            />
          </Routes>
        </BrowserRouter>
      </RBACProvider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
